import { apiRequest } from '@/services/http'
import type { TalentAccount } from '@/services/account'

export function uploadAvatar(file: File): Promise<{ user: TalentAccount }> {
  const form = new FormData()
  form.append('file', file)
  return apiRequest('/v1/me/avatar', { method: 'POST', body: form })
}

export function deleteAvatar(): Promise<{ user: TalentAccount }> {
  return apiRequest('/v1/me/avatar', { method: 'DELETE' })
}
